<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import moment from "moment";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED, DATE } from "@/constants";
import { mapState } from "vuex";
import { DOMAIN_GROUP_MODULE } from '@/state/modules/domainGroup'
import { domainGroupMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: i18n.t("label.listingX", [i18n.t('module.domainGroup')]),
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != 'Domain-group-update' && to.name != 'Domain-group-create') {
      sessionHelper.clearSearch(SESSION.DOMAIN_GROUP_SEARCH)
    }
    next();
  },
  async created() {
    await this.validPermissions();
    this.initSearchCriteria();
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: i18n.t("label.listingX", [i18n.t('module.domainGroup')]),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.domainGroup"),
          active: true,
        },
      ],
      statusDdl: ddlHelper.getActivationStatus(true),
      currentPage: 1,
      filter: "",
      selectedStatus: SHARED.DEFAULT_ALL_VALUE,
      permissions: sessionHelper.getPermissions(),
      createPermission: null,
      updatePermission: null,
      updateStatusPermission: null,
      readPermission: null,
      readAllPermission: null,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
    };
  },
  computed: {
    selectedStatusOption: {
      get() {
        return this.statusDdl.find((status) => status.value == this.selectedStatus) || null;
      },
      set(option) {
        this.selectedStatus = option ? option.value : null;
      },
    },
    ...mapState(DOMAIN_GROUP_MODULE, ['status']),
    fields() {
      let fields = [
        { key: "name", sortable: true, label: i18n.t("label.name"), },
        { key: "slug", sortable: true, label: i18n.t("label.slug"), },
      ]


      fields.push({ key: "countryCode", sortable: true, label: i18n.t("label.countryCode"), })
      fields.push({ key: "domainsCount", sortable: true, label: i18n.t("label.members"), })
      fields.push({ key: "playerLink", sortable: false, label: i18n.t("label.playerLink"), })
      fields.push({ key: "updatedAt", sortable: true, label: i18n.t("label.updatedAt"), })
      fields.push({ key: "isActive", sortable: true, label: i18n.t("label.status"), })
      fields.push({ key: "Action", sortable: false, label: i18n.t("label.action"), })

      return fields
    },
    tableRows() {
      return this.$store.state.domainGroup.list.data;
    },
    totalPage() {
      return this.$store.state.domainGroup.list.pagination.total;
    },
  },
  methods: {
    ...domainGroupMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      this.createPermission = jsonPermissions.some(p => p.code === "DOMAIN_CREATE");
      this.readPermission = jsonPermissions.some(p => p.code === "DOMAIN_READ");
      this.readAllPermission = jsonPermissions.some(p => p.code === "DOMAIN_READ_ALL");
      this.updatePermission = jsonPermissions.some(p => p.code === "DOMAIN_UPDATE");
      this.updateStatusPermission = jsonPermissions.some(p => p.code === "DOMAIN_UPDATE_STATUS");
    },
    initSearchCriteria() {
      let isDefault = true;

      if (sessionHelper.hasSearchCriteria(SESSION.DOMAIN_GROUP_SEARCH)) {
        isDefault = false;
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.DOMAIN_GROUP_SEARCH);
        this.currentPage = this.searchCriteria.pageNumber;
        this.filter = this.searchCriteria.searchValue;
        this.selectedStatus = this.searchCriteria.isActive;
      }

      if (isDefault) {
        this.searchCriteria = {
          pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
          pageSize: SHARED.DEFAULT_PAGE_SIZE,
          isActive: this.statusDdl[0].value,
          searchValue: "",
          searchArray: [],
        };
      }

      if (this.readPermission == true) {
        this.getDomainGroupList(this.searchCriteria);
      }
    },

    getDomainGroupList(filter) {
      this.getAllDomainGroups({ filter });
      this.searchCriteria = filter;
      sessionHelper.storeSearch(SESSION.DOMAIN_GROUP_SEARCH, filter);
    },

    pageNavigation(pageNumber) {
      let filter = sessionHelper.retrieveSearch(SESSION.DOMAIN_GROUP_SEARCH);
      filter.pageNumber = pageNumber;

      this.getDomainGroupList(filter);
    },

    searchListing() {
      this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;

      this.searchCriteria.searchValue = this.filter;
      this.searchCriteria.searchArray = [];
      this.searchCriteria.searchArray.push(this.filter);
      this.searchCriteria.isActive = this.selectedStatus;
      if (this.filter == '' || this.filter == null) {
        this.searchCriteria.pageNumber = 1;
        this.currentPage = 1;
      }
      this.getDomainGroupList(this.searchCriteria);
    },

    editStatus(group) {
      const data = {
        uuid: group.id,
        isActive: group.isActive,
      };

      this.updateDomainGroupStatus({ filter: this.searchCriteria, data });
    },

    formatDateTime(value) {
      return value ? moment(value).format(DATE.DATE_TIME_SHORT_TZ) : '-';
    },

    toDetailsPage(id) {
      let filter = sessionHelper.retrieveSearch(SESSION.DOMAIN_GROUP_SEARCH)
      filter.selectedRecordId = id
      sessionHelper.storeSearch(SESSION.DOMAIN_GROUP_SEARCH, filter)

      this.$router.push({
        name: 'Domain-group-update'
      })
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: left">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("label.search") }}
                    <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                      class="form-control form-control-sm ml-2" @change="searchListing"></b-form-input>
                  </label>
                  <label class="d-inline-flex align-items-center ml-2">
                    {{ $t("label.status") }}
                    <multiselect v-model="selectedStatusOption" :options="statusDdl" label="text" track-by="value"
                      :show-labels="false" :allow-empty="false" class="ml-2" style="width: 180px; display: inline-block;"
                      @input="searchListing"></multiselect>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: right">
                  <router-link tag="a" to="/domain-group/create" style="float: right; margin-bottom: 10px"
                    v-if="createPermission == true" class="btn btn-info w-md waves-effect waves-light">
                    {{ $t('label.createX', [$t('module.domainGroup')]) }}
                  </router-link>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                v-if="readPermission == true">
                <template #cell(slug)="data">
                  <code v-if="tableRows[data.index].slug">{{ tableRows[data.index].slug }}</code>
                  <span v-else>-</span>
                </template>

                <template #cell(playerLink)="data">
                  <code v-if="tableRows[data.index].playerLink">{{ tableRows[data.index].playerLink }}</code>
                  <span v-else class="text-muted">-</span>
                </template>

                <template #cell(updatedAt)="data">
                  {{ formatDateTime(tableRows[data.index].updatedAt) }}
                </template>

                <template #cell(isActive)="data">
                  <b-form-checkbox @change="editStatus(tableRows[data.index])" v-model="tableRows[data.index].isActive"
                    switch class="mb-1" :disabled="updateStatusPermission == false">
                  </b-form-checkbox>
                </template>

                <template #cell(action)="data">
                  <a href="javascript:void(0);" class="text-info" @click="toDetailsPage(tableRows[data.index].id)"
                    v-b-tooltip.hover v-if="updatePermission == true"
                    :title="$t('label.updateX', [$t('module.domainGroup')])">
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>
                </template>
              </b-table>
              <div style="text-align: center;" v-else>
                {{ $t('message.noPermissionMessage') }}
              </div>
            </div>
            <div class="row" v-if="this.readPermission == true">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage"
                      @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
